<div class="container-fluid py-3">
  <div class="row">

    @if(survey) {

      <div class="col-12 mb-3">
        <div class="row align-items-center mb-2">
          <div class="col-auto">
            <a
              [routerLink]="['../']"
              class="btn btn-light rounded-circle d-flex align-items-center justify-content-center"
              style="height: 4vh; width: 4vh;">
              <i class="material-icons" style="font-size: calc(0.8rem + 0.8vh);">arrow_back</i>
            </a>
          </div>
          <div class="col">
            <h4 class="mb-0"><b>{{ survey.title }}</b></h4>
            <small class="text-secondary">{{ survey.content }}</small>
          </div>
        </div>
        <div class="col-12">
          <span
            class="badge rounded-pill me-2"
            [ngClass]="{
              'text-bg-success': survey.status,
              'text-bg-secondary': !survey.status
            }">
            {{ survey.status ? 'Publicado' : 'No publicado' }}
          </span>
          <span class="badge rounded-pill text-bg-light">
            <i class="material-icons" style="font-size: 0.75rem; vertical-align: middle;">event</i>
            {{ survey.dueDate | dateToMoment: 'ddd DD MMM yyyy HH:mm' }}
          </span>
        </div>
      </div>

      <div class="col-12 rounded bg-white py-3 mb-4">
        <div class="row">

          <div class="col">
            <div class="row">
              <div class="col-12 mb-1 text-center">
                <i class="material-icons text-secondary">groups</i>
              </div>
              <div
                class="col-12 mb-2 text-center"
                style="font-size: calc(1.5rem + 1.5dvh);">
                {{ survey.total }}
              </div>
              <div class="col-12 mb-2 text-center">
                <small><b class="text-secondary">Número de participantes</b></small>
              </div>
            </div>
          </div>

          <div class="col">
            <div class="row">
              <div class="col-12 mb-1 text-center">
                <i class="material-icons text-secondary">how_to_vote</i>
              </div>
              <div
                class="col-12 mb-2 text-success text-center"
                style="font-size: calc(1.5rem + 1.5dvh);">
                {{ survey.questions.length > 0 ? survey.questions[0].totalVotes : 0 }}
              </div>
              <div class="col-12 mb-2 text-center">
                <small><b class="text-secondary">Número de votantes</b></small>
              </div>
            </div>
          </div>

          <div class="col">
            <div class="row">
              <div class="col-12 mb-1 text-center">
                <i class="material-icons text-secondary">pending_actions</i>
              </div>
              <div
                class="col-12 mb-2 text-danger text-center"
                style="font-size: calc(1.5rem + 1.5dvh);">
                {{ survey.questions.length > 0 ? survey.total - survey.questions[0].totalVotes : 0 }}
              </div>
              <div class="col-12 mb-2 text-center">
                <small><b class="text-secondary">Faltantes por votar</b></small>
              </div>
            </div>
          </div>

          <div class="col">
            <div class="row">
              <div class="col-12 mb-1 text-center">
                <i class="material-icons text-secondary">percent</i>
              </div>
              <div
                class="col-12 mb-2 text-primary text-center"
                style="font-size: calc(1.5rem + 1.5dvh);">
                {{ survey.questions.length > 0 && survey.total > 0 ? ((survey.questions[0].totalVotes / survey.total) * 100 | number:'1.0-0') : 0 }}%
              </div>
              <div class="col-12 mb-2 text-center">
                <small><b class="text-secondary">% de participación</b></small>
              </div>
            </div>
          </div>

        </div>
        <div class="progress mt-3" style="height: 6px;">
          <div
            class="progress-bar bg-success"
            role="progressbar"
            [style.width.%]="survey.questions.length > 0 && survey.total > 0 ? (survey.questions[0].totalVotes / survey.total) * 100 : 0">
          </div>
        </div>
      </div>

      <div class="col-12 rounded bg-white py-3 text-end mb-4">

        @if(!survey.status) {

          <button
            type="button"
            (click)="open()"
            ngbTooltip="Agregar pregunta"
            class="btn btn-success rounded-circle me-2">
            <i class="material-icons mt-1">add</i>
          </button>

          <button
            type="button"
            (click)="compressFile()"
            ngbTooltip="Agregar imagen"
            class="btn btn-success rounded-circle me-2">
            <i class="material-icons mt-1">add_photo_alternate</i>
          </button>

          <button
            type="button"
            (click)="selectPdfFile()"
            ngbTooltip="Agregar documento"
            class="btn btn-success rounded-circle me-2">
            <i class="material-icons mt-1">upload_file</i>
          </button>

        }

        <button
          type="button"
          (click)="getData()"
          class="btn btn-primary rounded-circle me-2">
          <i class="material-icons mt-1">refresh</i>
        </button>

      </div>

      @if (!survey.status || survey.files.length > 0) {

        <div class="col-12 mb-2">
          <small><b class="text-secondary">
            Archivos
          </b></small>
        </div>

        <div class="col-12 py-3 rounded bg-white mb-4 px-3">
          <div class="row">

            @for(file of survey.files; track $index) {

              <div class="col-4 col-md-3 col-lg-2 col-xl-1">
                <div class="row h-100">

                  <div class="col-12">
                    @if(file.fileType == 'image') {
                      <p-image
                        [src]="file.urlFile"
                        [alt]="file.fileId"
                        width="100%"
                        [preview]="true" />
                    } @else {
                      <div class="col-12 h-100">
                        <a
                          class="bg-light h-100 d-flex align-items-center justify-content-center"
                          [href]="file.urlFile"
                          target="_blank">
                          <i class="material-icons text-secondary">
                            picture_as_pdf
                          </i>
                        </a>
                      </div>
                    }
                  </div>

                </div>
              </div>

            }

          </div>
        </div>

      }

      <div class="col-12 mb-2">
        <small><b class="text-secondary">
          Preguntas
        </b></small>
      </div>

      <div class="col-12">
        <div class="row">

          @for (question of survey.questions; track $index) {
            <div class="col-12 col-md-6 col-lg-6 col-xl-4 px-3 mb-3">
              <div class="row">

                <div class="col-12 py-3 rounded bg-white">
                  <div class="row">

                    <div class="col-12 mb-4">
                      <div class="row">
                        <div class="col d-flex align-items-center">
                          <span class="badge rounded-pill text-bg-light me-2">{{ $index + 1 }}</span>{{ question.question }}
                        </div>
                        <div class="col d-flex justify-content-end">

                          @if(!survey.status) {

                            <button
                              (click)="open(question)"
                              type="button"
                              class="btn btn-light rounded-circle me-2 d-flex align-items-center justify-content-center"
                              style="height: 4vh; width: 4vh;">
                              <i
                                class="material-icons"
                                style="font-size: calc(0.8rem + 0.8vh);">
                                edit
                              </i>
                            </button>

                            <button
                              (click)="delete(question)"
                              type="button"
                              class="btn btn-danger rounded-circle me-2 d-flex align-items-center justify-content-center"
                              style="height: 4vh; width: 4vh;">
                              <i
                                class="material-icons"
                                style="font-size: calc(0.8rem + 0.8vh);">
                                delete
                              </i>
                            </button>

                          }

                        </div>
                      </div>
                    </div>

                    <div class="col-12 mb-4">

                      @if(!survey.status) {
                        <button
                          (click)="openAnswerItem(question)"
                          class="btn btn-outline-success w-100 d-flex align-items-center justify-content-center">
                          Agregar nueva opción
                        </button>
                      }

                    </div>

                    <div class="col-12">
                      <div class="row">

                        <div
                          class="col-12"
                          [ngClass]="{
                            'mb-3': question.answerItems.length > 0,
                          }">
                          <small><b class="text-secondary">Opciones</b></small>
                        </div>

                        @for (answerItem of question.answerItems; track $index) {
                          <div class="col-12 mb-3">
                            <div class="row align-items-center">
                              <div class="col">
                                {{ answerItem.answer }}
                              </div>
                              <div class="col-auto text-secondary" style="font-size: 0.85rem;">
                                {{ answerItem.totalVotes }} votos
                              </div>
                              @if(!survey.status) {
                                <div class="col-auto">
                                  <div
                                    ngbDropdown
                                    class="d-inline-block d-flex justify-content-end"
                                    placement="bottom-end">
                                    <button
                                      type="button"
                                      class="btn btn-sm"
                                      [id]="answerItem.answerId"
                                      ngbDropdownToggle>
                                      <span class="material-icons">
                                        <small>more_vert</small>
                                      </span>
                                    </button>
                                    <div ngbDropdownMenu>
                                      <button
                                        ngbDropdownItem
                                        (click)="openAnswerItem(question, answerItem)"
                                        class="d-flex align-items-center">
                                        <i class="material-icons text-secondary me-2">
                                          <small>edit</small>
                                        </i>
                                        Editar
                                      </button>
                                      <button
                                        ngbDropdownItem
                                        (click)="deleteAnswerItem(question, answerItem)"
                                        class="text-danger d-flex align-items-center">
                                        <i class="material-icons me-2">
                                          <small>delete</small>
                                        </i>
                                        Borrar
                                      </button>
                                    </div>
                                  </div>
                                </div>
                              }
                            </div>
                            <div class="progress mt-1" style="height: 8px;">
                              <div
                                class="progress-bar bg-success"
                                role="progressbar"
                                [style.width.%]="survey.total > 0 ? (answerItem.totalVotes / survey.total) * 100 : 0"
                                [attr.aria-valuenow]="answerItem.totalVotes"
                                aria-valuemin="0"
                                [attr.aria-valuemax]="survey.total">
                              </div>
                            </div>
                            <small class="text-secondary">
                              {{ survey.total > 0 ? ((answerItem.totalVotes / survey.total) * 100 | number:'1.1-1') : 0 }}%
                            </small>
                          </div>
                        }

                      </div>
                    </div>

                  </div>

                </div>

              </div>
            </div>
          }

        </div>
      </div>

    } @else {

      <div class="col-12 text-center">

        <div class="spinner-border" style="width: 3rem; height: 3rem;" role="status">
          <span class="visually-hidden">Loading...</span>
        </div>

      </div>

    }

  </div>
</div>
